import { BordersStyles, Box, Button, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  onEnable?: () => void
}

const Discarded = ({ onEnable }: Props) => {
  const border: BordersStyles = {
    bottom: {
      width: 's1',
      style: 'solid',
      color: 'grey400',
    },
  }

  return (
    <Box gap="s12" paddingX="s16" paddingY="s12" background="grey100" border={border}>
      <Box flexDirection="row">
        <Box flexDirection="column" gap="s4">
          <Text size="300" weight="medium" color="textPrimary">
            {i18n.t('split_documents.workflow_payslips.discarded.title')}
          </Text>
          <Text size="100" weight="medium" color="textPrimary">
            {i18n.t('split_documents.workflow_payslips.discarded.info')}
          </Text>
        </Box>
      </Box>
      <Box alignItems="flexEnd" style={{ width: '100%' }} justifyContent="spaceBetween">
        <Box paddingLeft="s8">
          <Box flexDirection="row" gap="s8">
            <Button onClick={onEnable} type="secondary">
              {i18n.t('split_documents.workflow_payslips.discarded.assign_employee')}
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default Discarded
